import { render, staticRenderFns } from "./debug-dialog.vue?vue&type=template&id=534bf10e&"
import script from "./debug-dialog.vue?vue&type=script&lang=js&"
export * from "./debug-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports